import { watch, type Ref } from 'vue';
import type { Router } from 'vue-router';
import { setGricsImportMenuVisible } from '@/sidebar-items';
import { gricsImportAvailability } from '@/stores/grics-import-availability';
import { GRICS_IMPORTS_ROUTE_NAME, hasGricsImportPermission } from '@/utils/grics-import-link';

/** Recheck after configuration edits and before deep links; stale sessions never enable a menu. */
export function installGricsImportAvailability(
  router: Router,
  me: Ref<{ permissions: string[] } | null | undefined>,
  availability = gricsImportAvailability,
): void {
  const allowed = () => hasGricsImportPermission(me.value?.permissions);
  const redirect = { path: '/gestion/tableau-de-bord' };

  watch(availability.configured, setGricsImportMenuVisible, { immediate: true, flush: 'sync' });

  watch(me, () => {
    availability.reset();
    if (allowed()) void availability.refresh();
  }, { immediate: true, flush: 'sync' });

  router.beforeEach(async (to, from) => {
    const imports = to.name === GRICS_IMPORTS_ROUTE_NAME;
    const leftConfiguration = from.path === '/core/configuration' && to.path !== from.path;
    if (imports || leftConfiguration) {
      if (allowed()) await availability.refresh();
      else availability.reset();
    }
    // The profile loads asynchronously on cold starts. The watch below rejudges that route.
    return imports && me.value && (!allowed() || !availability.configured.value) ? redirect : true;
  });

  watch([me, availability.status, router.currentRoute], () => {
    if (router.currentRoute.value.name !== GRICS_IMPORTS_ROUTE_NAME || !me.value) return;
    if (!allowed() || availability.status.value === false) void router.replace(redirect);
  });
}
